import storage from 'store'
import { login, phoneLogin, getInfo, logout, tokenByTimeStamp } from '@/api/login'
import { ACCESS_TOKEN, APP_LOADING } from '@/store/mutation-types'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    pageSize: 30,
    corpId: JSON.parse(localStorage.getItem('corpId')) || '',
    isfollowUpObj: storage.get('IS_FOLLOWUP_OBJ') || '',
    gloableLoading: false // 全局加载动画
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_PAGESIZE: (state, pagesize) => {
      state.pageSize = pagesize || 30
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_CORPID: (state, corpId) => {
      state.corpId = corpId
      localStorage.setItem('corpId', JSON.stringify(corpId))
    },
    SET_IS_FOLLOWUP_OBJ: (state, isfollowUpObj) => {
      state.isfollowUpObj = isfollowUpObj
      storage.set('IS_FOLLOWUP_OBJ', isfollowUpObj)
    },
    [APP_LOADING]: (state, gloableLoading) => {
      state.gloableLoading = gloableLoading
    }
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            storage.set(ACCESS_TOKEN, res.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 手机登录
    PhoneLogin ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo)
          .then((res) => {
            storage.set(ACCESS_TOKEN, res.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 扫码登录
    CodeLogin ({ commit }, timeStamp) {
      return new Promise((resolve, reject) => {
        tokenByTimeStamp(timeStamp)
          .then((res) => {
            storage.set(ACCESS_TOKEN, res.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', res.token)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then((res) => {
            const user = res.user
            const avatar = user.avatar
            if (res.roles && res.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit('SET_ROLES', res.roles)
              commit('SET_PERMISSIONS', res.permissions)
            } else {
              commit('SET_ROLES', ['ROLE_DEFAULT'])
            }
            commit('SET_NAME', user.nickName)
            commit('SET_AVATAR', avatar)
            commit('SET_INFO', {
              userId: user.userId,
admin: user.admin,
position: res.position,
              data: { ...res }
            })
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_PERMISSIONS', [])
            storage.remove(ACCESS_TOKEN)
          })
      })
    }
  }
}

export default user
